var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend"},[_vm._l((_vm.data),function(_legend){return [(_legend.backgroundColor)?_c('span',{key:_legend.label,style:({
        '--background-color': _legend.backgroundColor || _vm.white
      })},[_vm._v(_vm._s(_legend.label))]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }